export default __webpack_public_path__ + "static/media/2ec047e3ab08d26a63ded6d88219f009.png";